import * as ChannelService from '@channel.io/channel-web-sdk-loader'
import { useContext, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import styled from 'styled-components'

import { abrViewWithdrawalAccount } from '../../utils/abr'

import { StoresContext } from '../../provider/StoreProvider'

import { Wrap } from '../../components/container/Wrap'
import { Content } from '../../components/container/Content'
import { Button } from '../../components/button'
import { Text, StyledText } from '../../components/text'
import { Footer } from '../../components/footer'
import { Header } from '../../components/header'

import { Color } from '../../theme/color'

// *출금 계좌 등록 시작 페이지*
// 예치금 계좌 발급을 위한 출금 계좌 등록 시작 페이지
// 로그인, 본인인증을 해야지만 들어올 수 있으며, 출금 계좌/예치금 계좌 정보가 있으면 들어오지 못함
export const CreateWithdrawal = observer(() => {
  const {
    authStore: { userInfo },
    commonStore: { setShowTab, setInvalidAccess },
  } = useContext(StoresContext)

  const isAccount = !!userInfo?.withdrawalAccount && !!userInfo?.depositAccount

  useEffect(() => {
    abrViewWithdrawalAccount()
    ChannelService.track('view_withdrawal_account')
    setShowTab(false)
  }, [])

  useEffect(() => {
    if (isAccount) {
      setInvalidAccess(true)
    }
  }, [userInfo])

  if (isAccount) {
    return <></>
  }

  return (
    <Wrap>
      <Header type="SUB" title="예치금 계좌 생성하기" />
      <Content>
        <Container>
          <Text size={24} weight={600} lineHeight={34}>
            예치금 충전 계좌 발급을 위해
            <br />
            출금 계좌 등록이 필요해요.
          </Text>
          <NoticeBox>
            <Text size={14} weight={500} lineHeight={20} $textAlign="center">
              예치금 충전은,{' '}
              <Text size={14} weight={500} color="primary_5">
                등록하신 출금 계좌
              </Text>
              로만 가능해요.
            </Text>
            <Text size={14} weight={500} lineHeight={20} $textAlign="center">
              금융사의 정책으로{' '}
              <Text size={14} weight={500} color="primary_5">
                오픈 뱅킹
              </Text>
              (토스, 카카오뱅크 등),{' '}
              <Text size={14} weight={500} color="primary_5">
                간편 결제
              </Text>
              (네이버페이, 카카오페이 등)를 통한 입금은 제한될 수도 있어요.
            </Text>
          </NoticeBox>
          <Title size={14} weight={600} block={true}>
            1. 출금 계좌 등록하기
          </Title>
          <List>
            <Text size={14} lineHeight={22} block={true} color="text_secondary">
              • 출금 계좌는 서비스 가입자 본인 명의의 실계좌만 가능해요.
            </Text>
            <Text size={14} lineHeight={22} block={true} color="text_secondary">
              • 출금 계좌 등록 및 변경은 더보기&gt;개인정보관리&gt;출금 계좌에서 가능해요.
            </Text>
            <Text size={14} lineHeight={22} block={true} color="text_secondary">
              • 본 계좌 번호가 아닌 평생 계좌 번호(휴대폰, 사업자 번호 등)는 등록이 불가능해요.
            </Text>
            <Text size={14} lineHeight={22} block={true} color="text_secondary">
              • 같은 계좌이지만, 계좌 번호가 변경된 경우, 변경된 계좌 번호를 입력해 주세요.
            </Text>
          </List>
          <Title size={14} weight={600} block={true}>
            2. NH농협은행 예치금 충전 계좌 발급
          </Title>
          <List>
            <Text size={14} lineHeight={22} block={true} color="text_secondary">
              • 약관동의 후 NH농협 충전 계좌가 발급돼요.
            </Text>
          </List>
        </Container>
      </Content>
      <Footer>
        <Button
          type="primary"
          size="large"
          block={true}
          href="/account/withdrawal/banks"
          routeProps={{ replace: true, state: { prevPathname: window.location.pathname } }}
        >
          시작하기
        </Button>
      </Footer>
    </Wrap>
  )
})

const Container = styled.div`
  padding: 24px;
  padding-top: 58px;
`

const NoticeBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin: 32px 0;
  padding: 16px;
  border-radius: 8px;
  background-color: ${Color.primary_1};
`

const Title = styled(StyledText)`
  margin-bottom: 8px;
`

const List = styled.div`
  margin-bottom: 32px;
`
